import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { CustomModal } from "../../../core/components/base-modals";
import { PaymentAccount } from "@models/payment_account";
import { PaymentOption, ValidationError } from "@models";
import { BehaviorSubject, Observable } from "rxjs";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { InfoService } from "@core-services/info.service";

@Component({
	templateUrl: "./mandate-list-modal.component.html",
	styleUrls: ["./mandate-list-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class MandateListModalComponent extends CustomModal implements OnInit {
	private _sepaAccounts: BehaviorSubject<PaymentAccount[]> = new BehaviorSubject<PaymentAccount[]>([]);
	private _showMandate: boolean = false;
	private _bankAccount: PaymentAccount = new PaymentAccount();
	public showEmptySection: boolean = false;

	@Input() public showBackButton: boolean = true;

	public constructor(
		private apicallService: ApicallService,
		private infoService: InfoService,
		private masterdataService: MasterdataService
	) {
		super();
	}

	public ngOnInit(): void {
		if (!this.showMandate) {
			this.apicallService.get("user/sepa-mandates", new ApicallOption(PaymentAccount)).subscribe(
				(res) => {
					this._sepaAccounts.next(res);
					this.sepaAccounts.forEach((account) => {
						const sepaPaymentOption: PaymentOption = this.masterdataService.payment_options.find((p) =>
							this.masterdataService.isSepaProvider(p)
						);
						account.setProviderId(sepaPaymentOption.getId());
						account.setFields(sepaPaymentOption.getFields());
					});
					// Handles display of the empty-section after mandates have been fetched
					this.showEmptySection = this._sepaAccounts.getValue().length === 0;
				},
				(error) => {
					if (error instanceof ValidationError) {
						this.infoService.setError(error);
					} else {
						console.error(error);
					}
				}
			);
		}
	}

	public onButtonClick(s: string): void {
		if (s === "back") {
			this._showMandate = false;
		}
		if (s === "abort") {
			this.close();
		}
	}

	public openMandate(p: PaymentAccount): void {
		this._bankAccount = p;
		this._showMandate = true;
	}

	public get showMandate(): boolean {
		return this._showMandate;
	}

	@Input("showMandate")
	public set showMandate(b: boolean) {
		this._showMandate = b;
	}

	public get bankAccount(): PaymentAccount {
		return this._bankAccount;
	}

	@Input("bankAccount")
	public set bankAccount(p: PaymentAccount) {
		this._bankAccount = p;
	}

	public get sepaAccounts$(): Observable<PaymentAccount[]> {
		return this._sepaAccounts.asObservable();
	}

	public get sepaAccounts(): PaymentAccount[] {
		return this._sepaAccounts.getValue();
	}
}
